var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechFocusTabsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1014,
    height: 986,
    viewBox: "0 0 1014 986",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.119 33L0 986H560.881L1094 33H533.119Z",
    fill: "#0099DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590.202 0L245 617H441.798L787 0H590.202Z",
    fill: "#EC7405"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.17 33L542 986H598.835L1132 33H1075.17Z",
    fill: "#EC7405"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechFocusTabsBg);
export default __webpack_public_path__ + "static/media/tech-focus-tabs-bg.37b33b56ad2eb1fb171bcf704f20c1a8.svg";
export { ForwardRef as ReactComponent };